const config = {
  server: {
    protocol: process.env.VUE_APP_SERVER_PROTOCOL || 'https',
    host: process.env.VUE_APP_SERVER_HOST || 'localhost',
    port: parseInt(process.env.VUE_APP_SERVER_PORT) || 3000
  },
};
   
module.exports = config;